export enum CommercialPolicyType {
  CommercialAuto = 'ESBCommercialAuto',
  CommercialUmbrella = 'ESBCommercialUmbrella',
  WorkersCompensation = 'ESBWorkersComp',
  BusinessOwners = 'ESBBusinessowners',
  CommercialPackage = 'ESBCommPackage'
}

/**
 * Maps commercial policy types to their corresponding icon classes
 */
export const COMMERCIAL_POLICY_ICONS: Record<CommercialPolicyType, string> = {
  [CommercialPolicyType.CommercialAuto]: 'icon-commercial-auto',
  [CommercialPolicyType.CommercialUmbrella]: 'icon-commercial-umbrella',
  [CommercialPolicyType.WorkersCompensation]: 'icon-workers-compensation',
  [CommercialPolicyType.BusinessOwners]: 'icon-business-owners',
  [CommercialPolicyType.CommercialPackage]: 'icon-commercial-package'
};

/**
 * Maps commercial policy types to their display labels
 */
export const COMMERCIAL_POLICY_LABELS: Record<CommercialPolicyType, string> = {
  [CommercialPolicyType.CommercialAuto]: 'Commercial Auto',
  [CommercialPolicyType.CommercialUmbrella]: 'Commercial Umbrella',
  [CommercialPolicyType.WorkersCompensation]: "Workers' Compensation",
  [CommercialPolicyType.BusinessOwners]: 'Business Owners Policy',
  [CommercialPolicyType.CommercialPackage]: 'Commercial Package Policy'
};
